import React from 'react';
const _ = {
    find: require('lodash/find'),
    filter: require('lodash/filter'),
    findIndex: require('lodash/findIndex'),
    forEach: require('lodash/forEach'),
    sortBy: require('lodash/sortBy'),
    map:    require('lodash/map'),
};

const ShortCourseConstants = require('../../../../../app/shared/ShortCourseConstants');

const RichText = require('@muzzylane/react-mzl/dist/RichText');

import ScrollToBottom from '../../common/ScrollToBottom';
import CriteriaScores from './CriteriaScores';
import VoiceAudioArray from './VoiceAudioArray';

class CoachScriptElements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            voice_rich_text_id: '', voice_audio_count:0,
        };
        this.unsubscribes = [ this.props.playStore.store.listen(this.onPlayStoreChange) ]
    }

    componentDidMount() {
        this.onPlayStoreChange(); // trigger voice audio (if any)
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes; // delete so we can check this to see if the component is still mounted
    }

    getVoiceRichTextId=(props)=>{
        const playStore = props.playStore;
        let coach_script_id = playStore.getCoachScriptId();
        let action_index = playStore.getValidCoachActionIndex(); // get a real index
        let actionEntry = playStore.getCoachAction(coach_script_id, action_index);
        if (actionEntry) {
            return actionEntry.rich_text_id;
        }
    }

    onPlayStoreChange=()=>{
        let voice_rich_text_id = this.getVoiceRichTextId(this.props);
        if (voice_rich_text_id !== this.state.voice_rich_text_id) {
            if (voice_rich_text_id) {
                let voice_audio_count = this.props.playStore.getVoiceElementCountForRichText(voice_rich_text_id);
                this.setState({voice_rich_text_id,voice_audio_count});
            }
        }
    }
    
    makeVariableSubstitutions=(richText,coachVariables,rollParams)=>{
        return this.props.playStore.makeVariableSubstitutions(richText,coachVariables,rollParams);
    }
    
    render() {
        let {app,playStore, activityElement} = this.props;
        let coach_script_id = playStore.getCoachScriptId();
        const staticScriptEntry = _.find(ShortCourseConstants.COACH_SCRIPTS,{id:coach_script_id});
        if (!staticScriptEntry) {
            return null;
        }
        
        let criteriaScoresShown = false;
        let additionalRemedialShown = false;
        let activityElementShown = false;
        
        let current_action_index = playStore.getValidCoachActionIndex(); // get a real index
        let coachVariables = playStore.getCoachVariables();
        let { attemptData, latestAssessmentAttemptData, remedial_skills }  = playStore.getLastAttemptData();
        const canAdvanceReportCard = playStore.canAdvanceReportCard();
        const canAdvanceCoachScript = playStore.canAdvanceCoachScript();
        let canAdvance = (canAdvanceReportCard || canAdvanceCoachScript);

        let playStoreState = playStore.getStore().getState();
        let node_id = playStoreState.node_id;
        let node_gate;

        if (node_id) {
            let { gate, min_gate, max_gate, remediating } = playStore.getNodeGateStatus(node_id);
            node_gate = gate;
        }

        const reportPhase = playStore.getReportCardPhase();
        let reportPhaseText = playStore.getReportCardPhaseRichText();
        if (reportPhaseText) {
            reportPhaseText = this.makeVariableSubstitutions(reportPhaseText,coachVariables,{coach_script_id,action_index:current_action_index});
        }

        const doc = playStore.getDoc();
        const criteriaScoresStyle = doc.client_content.criteriaScoresStyle;
        
        if (!coach_script_id) {
            console.log("no coach script for current state"); // FIXME: remove debug spam
            return null;
        }
        
        let coachElements = [];
        if (this.props.includePriorCoachElements) {
            const prior_coach_script_id = playStore.getPriorCoachScriptId();
            const priorStaticScriptEntry = _.find(ShortCourseConstants.COACH_SCRIPTS,{id:prior_coach_script_id});
            let prior_elements = playStore.getPriorCoachActionDisplayElements();
            if (prior_elements) {
                let coachVariables = playStore.getPriorCoachVariables();

                for (var prior_action_index=0; prior_action_index < prior_elements.length; ++prior_action_index) {
                    let { actionEntry, richText, /*stickerSrc*/ } = prior_elements[prior_action_index];
                    if (!actionEntry) {
                        break; // skip empty element (failed condition)
                    }
                    const stickerSrc = null; // never on prior coach elements
                    let isRichTextBlank = true;
                    if (richText) {
                        isRichTextBlank = false;

                        // see if the rich text is completely blank
                        let dummyDoc = document.implementation.createHTMLDocument('dummy'); // stops browser from preload images in the temporary div 
                        let rtElem = $('<div/>',dummyDoc).html(richText);
                        if (!rtElem.text() && !rtElem.find('img').length) { // if no text and no images
                            isRichTextBlank = true;
                        }
                        
                        if (!isRichTextBlank) {
                            richText = this.makeVariableSubstitutions(richText,coachVariables,{coach_script_id: prior_coach_script_id, action_index: prior_action_index});
                        }
                    } // if (coach) richText
                    
                    let showCriteriaScores = (!criteriaScoresShown && priorStaticScriptEntry && priorStaticScriptEntry.showCriteriaScores && attemptData);

                    let showAdditionalRemedialSkills = (!additionalRemedialShown && actionEntry.showAdditionalRemedialSkills &&  remedial_skills && (remedial_skills.length > 1));
                    // let showActivityElement = (!activityElementShown && !!activityElement && actionEntry.showActivityElements);
                    let showActivityElement = false; // don't show this in prior elements
                    
                    coachElements.push(
                        <div className="coach-action-display" key={`prior-${prior_action_index}`}>
                            { (richText && !isRichTextBlank) ? 
                            <div className="coach-dialog-section">
                                <RichText outerClassName="coach-rt" app={app} richText={richText}/> 
                                { (stickerSrc /*&& !showActivityElement*/) ?
                                <div className="coach-sticker">
                                    <img className="coach-sticker" alt="" src={stickerSrc} />
                                </div>
                                : null}
                            </div>
                            : null }
                            { showCriteriaScores ?
                            <div className="critera-scores-section">
                                <CriteriaScores skillsInvolved={attemptData.skillsInvolved} node_gate={node_gate} latestAssessmentAttemptData={latestAssessmentAttemptData} criteriaScoresStyle={criteriaScoresStyle} 
                                    reportPhase={ShortCourseConstants.REPORT_CARD_PHASE.END} app={app} richText={reportPhaseText}/>
                            </div>
                            : null }
                            { (showAdditionalRemedialSkills && (!showCriteriaScores || !canAdvanceReportCard)) ? 
                            <div className="remedial-skill-section">
                                <div className="line-break">&nbsp;</div>
                                <h3>{'Additional areas to think about for next time:'}</h3>
                                { _.map(remedial_skills.slice(1),(sk,i)=>(
                                    <div key={i} className={"remedial-row"}>
                                        <span className="name">{sk.subskill.display_name}</span>
                                        <span className="description">{sk.subskill.description}</span>
                                    </div>
                                ))}
                            </div>
                            : null }
                            { (showActivityElement && (!showCriteriaScores || !canAdvanceReportCard)) ? 
                            <div className="coach-dialog-section">
                                {activityElement}
                                { /*stickerSrc ?
                                <div className="coach-sticker">
                                    <img className="coach-sticker" alt="" src={stickerSrc} />
                                </div>
                                : null */}
                            </div>
                            : null }
                        </div>
                    );
                    // only show these once per coach entry (even if different entry actions say to show them)
                    if (showCriteriaScores) {
                        criteriaScoresShown = true;
                    }
                    if (showAdditionalRemedialSkills) {
                        additionalRemedialShown = true;
                    }
                    if (showActivityElement) {
                        activityElementShown = true;
                    }
                } // for prior elements
            } // if there are prior elements
        } // if we allow prior coach elements

        for (var action_index=0; action_index <= current_action_index; ++action_index) {
            let { actionEntry, richText, stickerSrc} = playStore.getCoachActionDisplayElements(coach_script_id, action_index);
            if (!actionEntry) {
                // condition failed
                continue;
            }
            let isCurrentAction = (action_index === current_action_index);
            let isLastAction = (isCurrentAction && !canAdvance );

            if (!isCurrentAction) {
                stickerSrc = null; // don't show sticker except for last node
            }
            if (stickerSrc) {
                stickerSrc = stickerSrc.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
            }
            if (!richText) {
                console.log(`unable to find programmatic text entry for '${coach_script_id}'`);
            }
            let isRichTextBlank = true;
            if (richText) {
                isRichTextBlank = false;

                // see if the rich text is completely blank
                let dummyDoc = document.implementation.createHTMLDocument('dummy'); // stops browser from preload images in the temporary div 
                let rtElem = $('<div/>',dummyDoc).html(richText);
                if (!rtElem.text() && !rtElem.find('img').length) { // if no text and no images
                    isRichTextBlank = true;
                }
                
                if (!isRichTextBlank) {
                    richText = this.makeVariableSubstitutions(richText,coachVariables,{coach_script_id,action_index});
                }
            } // if (coach) richText
            

            let showCriteriaScores = (!criteriaScoresShown && staticScriptEntry.showCriteriaScores && attemptData);
            let showAdditionalRemedialSkills = (!additionalRemedialShown && actionEntry.showAdditionalRemedialSkills &&  remedial_skills && (remedial_skills.length > 1));
            // let showActivityElement = (!activityElementShown && !!activityElement) && actionEntry.showActivityElements);
            let showActivityElement = (isLastAction && !activityElementShown && !!activityElement); // show activityElement for redmine #6166 (ignores coach script checkbox)
            
            coachElements.push(
                <div className="coach-action-display" key={action_index}>
                    { (richText && !isRichTextBlank) ? 
                    <div className="coach-dialog-section">
                        <RichText outerClassName="coach-rt" app={app} richText={richText}/> 
                        { (stickerSrc /*&& !showActivityElement*/) ?
                        <div className="coach-sticker">
                            <img className="coach-sticker" alt="" src={stickerSrc} />
                        </div>
                        : null}
                    </div>
                    : null }
                    { showCriteriaScores ?
                    <div className="critera-scores-section">
                        <CriteriaScores skillsInvolved={attemptData.skillsInvolved} node_gate={node_gate} latestAssessmentAttemptData={latestAssessmentAttemptData} criteriaScoresStyle={criteriaScoresStyle} 
                            reportPhase={reportPhase} app={app} richText={reportPhaseText}/>
                    </div>
                    : null }
                    { (showAdditionalRemedialSkills && (!showCriteriaScores || !canAdvanceReportCard)) ? 
                    <div className="remedial-skill-section">
                        <div className="line-break">&nbsp;</div>
                        <h3>{'Additional areas to think about for next time:'}</h3>
                        { _.map(remedial_skills.slice(1),(sk,i)=>(
                            <div key={i} className={"remedial-row"}>
                                <span className="name">{sk.subskill.display_name}</span>
                                <span className="description">{sk.subskill.description}</span>
                            </div>
                        ))}
                    </div>
                    : null }
                    { (showActivityElement && (!showCriteriaScores || !canAdvanceReportCard))? 
                    <div className="coach-dialog-section">
                        {activityElement}
                        {/* stickerSrc ?
                        <div className="coach-sticker">
                            <img className="coach-sticker" alt="" src={stickerSrc} />
                        </div>
                        : null */}
                    </div>
                    : null }
                </div>
            );
            
            // only show these once per coach entry (even if different entry actions say to show them)
            if (showCriteriaScores) {
                criteriaScoresShown = true;
            }
            if (showAdditionalRemedialSkills) {
                additionalRemedialShown = true;
            }
            if (showActivityElement) {
                activityElementShown = true;
            }
        } // for actions

        if (!coachElements.length) {
            console.log(`no action elements to display for coach_script_id ${coach_script_id}`);
            let isLastAction = true; // no actions available
            let showCriteriaScores = (!criteriaScoresShown && staticScriptEntry.showCriteriaScores && attemptData);
            let showActivityElement = (isLastAction && !activityElementShown && !!activityElement); // show activityElement for redmine #6166 (ignores coach script checkbox)
           
            if (showCriteriaScores || showActivityElement) {
                coachElements.push(
                    <div className="coach-action-display" key={'no-actions-to-show'}>
                        { showCriteriaScores ?
                        <div className="critera-scores-section">
                            <CriteriaScores skillsInvolved={attemptData.skillsInvolved} node_gate={node_gate} latestAssessmentAttemptData={latestAssessmentAttemptData} criteriaScoresStyle={criteriaScoresStyle} 
                                reportPhase={reportPhase} app={app} richText={reportPhaseText}/>
                        </div>
                        : null }
                        { (showActivityElement && (!showCriteriaScores || !canAdvanceReportCard))? 
                        <div className="coach-dialog-section">
                            {activityElement}
                        </div>
                        : null }
                    </div>
                );
            }
        }
        
        let rollParams = {
            coach_script_id: playStore.getCoachScriptId(),
            action_index: playStore.getValidCoachActionIndex()
        };

        return (
            <div className="coach-conversation">
                {coachElements}
                <ScrollToBottom changeDetect={String(coachElements.length)}/>
                { this.state.voice_audio_count ?
                <VoiceAudioArray rich_text_id={this.state.voice_rich_text_id} playStore={this.props.playStore} coachVariables={coachVariables} rollParams={rollParams} onFinish={this.props.onAudioFinish}/>
                : null }
            </div>
        );
    } // render
} // CoachScriptElements

export default CoachScriptElements;